










































import { Component, Vue, Prop } from 'vue-property-decorator';
import token from '@/modules/FPKG-20000-Util/prototypes/TokenCode';


@Component
export default class HeaderFunction extends Vue {
  // eslint-disable-next-line class-methods-use-this
  clearCache() {
    window.location.reload(true);
  }

  private userAccount() {
    const that = this;
    const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
    return user.p3_account.p3_ant_account;
  }

  private changePass() {
    this.$router.push('/changePassword');
  }

  private async logout() {
    const res = await this.$http.put('account/auth/logout');
    this.$router.push('/login');
  }
}
